import { render, staticRenderFns } from "./ContactRecords.vue?vue&type=template&id=3d586edf&scoped=true&"
import script from "./ContactRecords.vue?vue&type=script&lang=js&"
export * from "./ContactRecords.vue?vue&type=script&lang=js&"
import style0 from "./ContactRecords.vue?vue&type=style&index=0&id=3d586edf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d586edf",
  null
  
)

export default component.exports